export const all_routes = {
  home: "/",

  // Blog Routes
  //blogGrid: "/blog/blog-grid",
  blogGridSidebarRight: "/article",
  //blogGridSidebarLeft: "/blog/blog-grid-sidebar-left",
  //blogList: "/blog/blog-list",
  //blogListSidebarRight: "/blog/blog-list-sidebar-right",
  //blogListSidebarLeft: "/blog/blog-list-sidebar-left",
  //blogCarousel: "/blog/blog-carousel",
  //blogDetails: "/blog/blog-details",
  blogDetailsSidebarRight: "/article/:slug",
  //blogDetailsSidebarLeft: "/blog/blog-details-sidebar-left",

  // Pages Routes
  aboutUs: "/about-us",
  comingSoon: "/coming-soon",
  error404: "/error-404",
  //events: "/pages/events",
  //eventdetails: "/pages/event-details",
  serviceDetail: "/services/details",
  laneRental: "/lane-rental",
  bookACoach: "/book-a-coach",
  hpcActive: "/hpc-active",
  services: "/services",
  termsCondition: "/terms-condition",
  testimonials: "/testimonials",
  //testimonialsCarousel: "/pages/testimonials-carousel",
  maintenance: "/maintenance",
  cookiePolicy: "/cookie-policy",
  pricing: "/pricing",
  ourTeams: "/our-teams",
  myProfile: "/user/my-profile",
  faq: "/faq",
  gallery: "/gallery",
  //lessonOrderConfirm: "/coaches/lesson-order-confirm",
  //lessonPayment: "coaches/lesson-payment",
  //lessonPersonalinfo: "coaches/lesson-personalinfo",

  // Coaches Routes
  bookingCancelled: "/coaches/booking-cancelled",
  bookingCompleted: "/coaches/booking-completed",
  //allCourt: "/coaches/all-court",
  //appointmentDetails: "/coaches/appointment-details",
  //addCourt: "/coaches/add-court",
  //activeCourt: "/coaches/active-court",
  //inactiveCourt: "/coaches/inactive-court",
  coachDetail: "/location/:locationId/coaches/:id/:name",

  // Booking flow
  bookingType: "/booking-type",
  bookingAvailability: "/booking-type/:bookingType/location/:locationId/time&date",
  bookingPersonalInformation: "/booking-type/:bookingType/location/:locationId/personal-information",
  bookingPayment: "/booking-type/:bookingType/location/:locationId/payment",
  bookingSummary: "/booking/summary/:refCode",
  bookingLocation: "/booking-type/:bookingType/location",
  bookingAddOns: "/booking-type/:bookingType/location/:locationId/add-ons",
  
  //coachBookingAvailability: "/booking-type/:bookingType/location/:locationId/time&date",
  coachPersonalInfo: "/coaches/coach-personalinfo",
  coachOrederConfirm: "/coaches/coach-order-confirm",
  coachPayment: "/coaches/coach-payment",
  invoice: "/coaches/invoice",

  //lessonTimeDate: "/coaches/lesson-timedate",
  //lessonType: "/coaches/lesson-type",






  //coachEarning: "/coaches/coach-earning",
  coachesGrid: "/location/:locationId/coaches",
  //coachesGridSidebar: "/coaches/coaches-sidebar-grid",
  //coachesList: "/coaches/coaches-list",
  //coachesListSidebar: "/coaches/coaches-sidebar-list",
  //coachesMap: "/coaches/coaches-map",
  //coachRequest: "/coaches/coach-request",
  //coachWallet: "/coaches/coach-wallet",
  //coachProfile: "/coaches/coach-profile",
  //coachesMapSidebar: "/coaches/coaches-map-sidebar",
  //earningCoaching: "/coaches/earning-coaching",

  // Court rental
  // cagecheckout: "/coaches/cage-checkout",
  // cagedetails: "/coaches/cage-details",
  // cageordeconfirm: "/coaches/cage-order-confirm",
  // cagepersonalinfo: "/coaches/cage-personalinfo",
  // settingLesson: "/coaches/setting-lesson",
  // settingPassword: "/coaches/setting-password",
  // settingAvalibilty: "/coaches/setting-availability",
  // profileOtherSetting: "/coaches/profile-othersetting",
  //coachDashboard: "coaches/coach-dashboard",
  // coachBooking: "/coaches/coach-booking",
  // coachChat: "/coaches/coach-chat",
  //venueDetails: "/coaches/venue-details",

  // User Routes
  //userComplete: "/user/bookings/completed",
  userDashboardProfiles: "/user/user-dashboard-profiles",
  userDashboard: "/user/dashboard",
  userInvoice: "/user/user-invoice",
  userBookings: "/user/bookings/:status",
  userBookingsPrefix: "/user/bookings",
  //userChat: "/user/user-chat",
  userCoaches: "/user/user-coaches",
  userProfile: "/user/settings/profile",
  userSettingPassword: "/user/settings/password",
  userProfileOtherSetting: "/user/settings/other",
  // userCancelled: "/user/bookings/cancelled",
  // userOngoing: "/user/bookings/ongoing",
  userWallet: "/user/user-wallet",

  //Listing Routes
  // listingGridSidebar: "/listing/listing-grid-sidebar",
  locations: "/location",
  location: "/location/:locationId",
  lanes: "/location/:locationId/lanes",
  // listingListSidebar: "/listing/listing-list-sidebar",
  // listingList: "/listing/listing-list",
  // listingMapSidebar: "/listing/listing-map-sidebar",
  // listingMap: "/listing/listing-map",

  // Auth Routes
  register: "/auth/register",
  login: "/auth/login",
  changePassword: "/auth/change-password",
  forgotPasssword: "/auth/forgot-password",

  //contact-us
  contactUs: "/contact-us",
};
